import { render, staticRenderFns } from "./PlayerSolo.vue?vue&type=template&id=568f39aa"
import script from "./PlayerSolo.vue?vue&type=script&lang=js"
export * from "./PlayerSolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports